import { EditTabsPattern } from '@/components'
import { useComponentProvider } from '@/components/ViewComponentModal/ViewComponentProvider'

import { ConfigData, History, SettingsTab } from './tabs'

const tabs = [
  { component: <SettingsTab />, name: 'settings' },
  { component: <History />, name: 'version' },
  { component: <ConfigData />, name: 'config' },
]

export const SentimentCheck = () => {
  const { componentID, useUrl } = useComponentProvider()
  return (
    <EditTabsPattern
      defaultTab="settings"
      showTabs={!!componentID}
      tabs={tabs}
      urlParams={useUrl}
    />
  )
}
